import { render, staticRenderFns } from "./CRUDTableDetail.vue?vue&type=template&id=3539758c&scoped=true"
import script from "./CRUDTableDetail.vue?vue&type=script&lang=js"
export * from "./CRUDTableDetail.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableDetail.vue?vue&type=style&index=0&id=3539758c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539758c",
  null
  
)

export default component.exports